import React from 'react';
import { Reporting } from './components';
import PrivateRoute from 'PrivateRoutes';

const routes = () => (
  <PrivateRoute exact path="/reporting" component={Reporting} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/reporting/Reporting/routes.js